module.exports = __webpack_public_path__ + "static/media/gc-taxi-bags.1b296233.png";